// views/MainPage/HomePage/components/TemporaryOutOfOrder/TemporaryOutOfOrder.jsx
import styles from './TemporaryOutOfOrder.module.css';

const TemporaryOutOfOrder = () => {
  return (
    <section className={styles.wrapper} role="alert" aria-live="polite">
      <div className={styles.card}>
        <span className={styles.icon} aria-hidden="true">🛠️</span>
        <h1 className={styles.title}>
          Oups... Hlavní stránka je dočasně <span className={styles.accent}>mimo provoz.</span>
        </h1>
        <p className={styles.text}>
          Omlouváme se za potíže a děkujeme za pochopení.
        </p>
        <div className={styles.status}>
          <span className={styles.dot} aria-hidden="true" />
          <strong>Přihlašování je aktivní.</strong>
        </div>
      </div>
    </section>
  );
};

export default TemporaryOutOfOrder;